module.exports = {
  apiHost: 'https://api.dayafternow.com',
  clientHost: 'https://admin.dayafternow.com/app',
  master: 'https://admin.dayafternow.com',
  recaptcha: {
    sitekey: '6Ld9HyMUAAAAANRcOyDZMjVL3zT9XEPRx-Jw6iI9'
  },
  stripe: {
    pk: 'pk_live_KuldPjWmm4upZzgFtpV1rOow'
  },
  gaKey: 'UA-103026428-1',
  paypal: {
    client: {
      sandbox: '',
      production: 'AfcIH3bPRQsqZt2HprQyUR9eL02D5Wi09KYU7vXCbpRaHru-ToPjbtXHohcHquAuGq3SKvdoqkY84DEl'
    },
    env: 'production',
    style: {
      label: 'pay', // checkout | credit | pay
      size: 'responsive',    // small | medium | responsive
      shape: 'rect',     // pill | rect
      color: 'silver',      // gold | blue | silver
      tagline: false  // remove tagline
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/config.js